import React from "react";
import Header from "../../components/Header";
import { getAuth, onAuthStateChanged, signOut } from 'firebase/auth';
import { getDatabase, ref, child, get, onValue, update, set, push, remove } from "firebase/database";
import CodeMirror from "react-codemirror";
import "./Coding.css";
import "./dracula.css";
import VideoChat from "../../components/VideoChat";
import Eval from "../../components/Eval";
import { RemoveScroll } from "react-remove-scroll";
import Dropdown from "../../components/Dropdown";
import ReactGA from "react-ga";
import { Resizable } from "re-resizable";
import Hotkeys from 'react-hot-keys';
import History from '../../components/History';
import Card from "../../components/Card";
import { IconContext } from "react-icons";
import { CiLogin, CiLogout } from "react-icons/ci";
import { FiShare2 } from "react-icons/fi";
import { useNavigate } from "react-router-dom";

require("codemirror/lib/codemirror.css");
require("codemirror/mode/javascript/javascript");
require("codemirror/mode/ruby/ruby");
require("codemirror/mode/python/python");
require("codemirror/mode/swift/swift");
require("codemirror/mode/clike/clike");
require("codemirror/mode/go/go");
require("codemirror/mode/php/php");
require("codemirror/mode/r/r");
require("codemirror/mode/clike/clike");
require("codemirror/addon/display/placeholder");
require("codemirror/addon/edit/matchbrackets");
require("codemirror/addon/edit/matchtags");
require("codemirror/addon/edit/closebrackets");
require("codemirror/addon/edit/closetag");

function initializeAnalytics() {
  ReactGA.initialize("UA-154969560-1");
  ReactGA.pageview("/Coding");
}

function CodingPageWrapper(props) {
  const navigate = useNavigate();
  return <CodingPage {...props} navigate={navigate} />;
}

class CodingPage extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      code: "Loading...",
      loading: false,
      mode: "python",
      language_id: 71,
      language: [
        {
          id: 0,
          language_id: 63,
          title: " JS",
          mode: "javascript",
          fa_icon: "FaJsSquare",
          selected: false,
          key: "language",
        },
        {
          id: 1,
          language_id: 71,
          title: " Python",
          mode: "python",
          fa_icon: "FaPython",
          selected: false,
          key: "language",
        },
        {
          id: 2,
          language_id: 72,
          title: " Ruby",
          mode: "ruby",
          fa_icon: "FaGem",
          selected: false,
          key: "language",
        },
        {
          id: 3,
          language_id: 83,
          title: " Swift",
          mode: "swift",
          fa_icon: "FaSwift",
          selected: false,
          key: "language",
        },
        {
          id: 4,
          language_id: 62,
          title: " Java",
          mode: "text/x-java",
          fa_icon: "FaJava",
          selected: false,
          key: "language",
        },
        {
          id: 5,
          language_id: 60,
          title: " Go",
          mode: "text/x-go",
          fa_icon: "FaGoogle",
          selected: false,
          key: "language",
        },
        {
          id: 6,
          language_id: 78,
          title: " Kotlin",
          mode: "text/x-kotlin",
          fa_icon: "FaAndroid",
          selected: false,
          key: "language",
        },
        {
          id: 7,
          language_id: 68,
          title: " PHP",
          mode: "application/x-httpd-php",
          fa_icon: "FaPhp",
          selected: false,
          key: "language",
        },
        {
          id: 8,
          language_id: 80,
          title: " R",
          mode: "text/x-rsrc",
          fa_icon: "FaRProject",
          selected: false,
          key: "language",
        },
        {
          id: 9,
          language_id: 81,
          title: " Scala",
          mode: "text/x-scala",
          fa_icon: "FaBars",
          selected: false,
          key: "language",
        },
        {
          id: 10,
          language_id: 54,
          title: " C++",
          mode: "text/x-c++src",
          fa_icon: "SiCplusplus",
          selected: false,
          key: "language",
        },
        {
          id: 11,
          language_id: 43,
          title: " plntxt",
          mode: "text/plain",
          fa_icon: "BsCursorText",
          selected: false,
          key: "language",
        },
      ],
      currlang: " Python",
      cursorPosition: {
        line: 0,
        ch: 0,
      },
      witeboard: null,
      sessionid: null,
      darkMode: this.props.darkMode,
      evalExtend: false,
      timerExtend: true,
      whiteboardExtend: false,
      openAiToggle: false,
      borderToggle: true,
      completionToggle: sessionStorage.getItem("completionToggle") === "true" || false,
      flanT5Toggle: false,
      anthropicToggle: false,
      GrokAIToggle: false,
      PaLMToggle: false,
      GeminiToggle: false,
      token: null,
      evalOutput: sessionStorage.getItem("evalOutput") || null,
      compileOutput: sessionStorage.getItem("compileOutput") || null,
      memory: null,
      time: null,
      history: {},
      output: null,
      output2: "",
      output3: "",
      modelOutput: [],
      usage: null,
      cardCreated: null,
      hotkeys: null,
      cards: [],
      cardsOpenAI: [],
      cardsHF: [],
      cardsPaLM: [],
      cardsGemini: [],
      cardsAnthropic: [],
      lastQueryTime: null,
      login: false,
      transcript: [],
      aiAssistant: [],
      isDevelopment: false,
      isTyping: false,
      typingTimeout: null,
      firebaseUpdateTimeout: null,
      isPrivate: false,
      // Anti-abuse state
      lastRunTime: 0,
      runCount: 0,
      abuseWarning: null,
      // Share modal state
      showShareModal: false,
      shareLink: "",
      copySuccess: false
    };
    this.cardsEndRef = React.createRef();
    this.scrollToBottom = this.scrollToBottom.bind(this);
    this.toggleLanguage = this.toggleLanguage.bind(this);
    this.toggleExtend = this.toggleExtend.bind(this);
    this.toggleTimer = this.toggleTimer.bind(this);
    this.toggleWhiteboard = this.toggleWhiteboard.bind(this);
    this.toggleBorder = this.toggleBorder.bind(this);
    this.toggleCompletion = this.toggleCompletion.bind(this);
    this.whiteboardRender = this.whiteboardRender.bind(this);
    this.loginRender = this.loginRender.bind(this);
    this.toolTipRender = this.toolTipRender.bind(this);
    this.runCode = this.runCode.bind(this);
    this.useOpenAI = this.useOpenAI.bind(this);
    this.useHuggingFace = this.useHuggingFace.bind(this);
    this.useAnthropic = this.useAnthropic.bind(this);
    this.usePaLM = this.usePaLM.bind(this);
    this.useGemini = this.useGemini.bind(this);
    this.toggleAnthropic = this.toggleAnthropic.bind(this);
    this.togglePaLM = this.togglePaLM.bind(this);
    this.toggleGrokAI = this.toggleGrokAI.bind(this);
    this.toggleGemini = this.toggleGemini.bind(this);
    this.toggleFlanT5 = this.toggleFlanT5.bind(this);
    this.mapCards = this.mapCards.bind(this);
    this.closeCard = this.closeCard.bind(this);
    this.copyCard = this.copyCard.bind(this);
    this.poweredBy = this.poweredBy.bind(this);
    this.logout = this.logout.bind(this);
    this.login = this.login.bind(this);
    this.acceptSuggestion = this.acceptSuggestion.bind(this);
    this.denySuggestion = this.denySuggestion.bind(this);
    this.updateAssistant = this.updateAssistant.bind(this);
    this.auth = getAuth();
    this.db = getDatabase();
    // Anti-abuse tracking
    this.runCodeThrottle = this.runCodeThrottle.bind(this);
    this.checkAbuseLimits = this.checkAbuseLimits.bind(this);
    this.showAbuseWarning = this.showAbuseWarning.bind(this);
    // Share functionality
    this.openShareModal = this.openShareModal.bind(this);
    this.closeShareModal = this.closeShareModal.bind(this);
    this.copyToClipboard = this.copyToClipboard.bind(this);
    this.generateShareLink = this.generateShareLink.bind(this);
    this.togglePrivacy = this.togglePrivacy.bind(this);
  }

  componentDidMount() {
    this.initializeSession(this.props.sessionid);
  }

  componentDidUpdate(prevProps) {
    // If the sessionid prop changed, reinitialize the session
    if (prevProps.sessionid !== this.props.sessionid) {
      this.initializeSession(this.props.sessionid);
    }
  }

  initializeSession(sessionid) {
    const self = this;
    const dbRef = ref(this.db);
    const auth = getAuth();
    const user = auth.currentUser;

    // Determine if the session is private
    if (user) {
      const userId = user.uid;
      get(ref(this.db, `private-sandboxes/${userId}/${sessionid}`)).then((snapshot) => {
        if (snapshot.exists()) {
          this.setState({ isPrivate: true });
          // Load from private-sandboxes
          const data = snapshot.val();
          this.setState({
            code: data.content || '',
            evalOutput: data.evalOutput || undefined,
            compileOutput: data.compileOutput || undefined,
            witeboard: "https://witeboard.com/" + sessionid,
            sessionid: sessionid,
          });
        } else {
          // If not in private-sandboxes, try code-sessions
          get(ref(this.db, `code-sessions/${sessionid}`)).then((snapshot) => {
            if (snapshot.exists()) {
              this.setState({ isPrivate: false });
              const data = snapshot.val();
              this.setState({
                code: data.content || '',
                evalOutput: data.evalOutput || undefined,
                compileOutput: data.compileOutput || undefined,
                witeboard: "https://witeboard.com/" + sessionid,
                sessionid: sessionid,
              });
            } else {
              console.error("Session not found");
            }
          });
        }
      });
    } else {
      // For non-authenticated users, load from code-sessions
      get(ref(this.db, `code-sessions/${sessionid}`)).then((snapshot) => {
        if (snapshot.exists()) {
          this.setState({ isPrivate: false });
          const data = snapshot.val();
          this.setState({
            code: data.content || '',
            evalOutput: data.evalOutput || undefined,
            compileOutput: data.compileOutput || undefined,
            witeboard: "https://witeboard.com/" + sessionid,
            sessionid: sessionid,
          });
        } else {
          console.error("Session not found");
        }
      });
    }

    // Add cursor activity handler after CodeMirror is initialized
    const setupCursorTracking = () => {
      if (self.codemirror && self.codemirror.getCodeMirror()) {
        const cm = self.codemirror.getCodeMirror();
        let cursorUpdateTimeout;

        cm.on('cursorActivity', () => {
          const cursorPosition = cm.getCursor();
          // Only update if position actually changed
          if (cursorPosition.line !== self.state.cursorPosition.line ||
            cursorPosition.ch !== self.state.cursorPosition.ch) {

            // Clear any pending cursor updates
            if (cursorUpdateTimeout) {
              clearTimeout(cursorUpdateTimeout);
            }

            // Update local state immediately for responsive cursor movement
            self.setState({ cursorPosition });

            // Debounce Firebase updates to prevent rapid writes
            cursorUpdateTimeout = setTimeout(() => {
              // Only update Firebase if we're not currently typing
              if (!self.isTyping) {
                sessionStorage.setItem('cursorPosition', JSON.stringify(cursorPosition));
                update(child(dbRef, `code-sessions/${self.state.sessionid}`), {
                  cursorPosition: cursorPosition
                });
              }
            }, 500);
          }
        });
      }
    };

    const isDevelopment = process.env.REACT_APP_IS_DEVELOPMENT === 'true';
    this.setState({ isDevelopment }, () => {
      // Setup cursor tracking after initial state is set
      setupCursorTracking();
    });

    // Utility function to simplify getting session storage items as booleans
    const getBooleanFromSession = (key) => sessionStorage.getItem(key) === 'true';

    if (sessionStorage.getItem("currlang")) {
      const key = sessionStorage.getItem("key");
      const mode = sessionStorage.getItem("mode");
      const language_id = sessionStorage.getItem("language_id");
      const currlang = sessionStorage.getItem("currlang");
      self.setState({ key, mode, language_id, currlang });
    }

    const historyFromLocal = localStorage.getItem("history");
    if (historyFromLocal) {
      this.setState({ history: JSON.parse(historyFromLocal) });
    }

    const borderToggleFromSession = sessionStorage.getItem("borderToggle");
    if (borderToggleFromSession) {
      this.setState({ borderToggle: JSON.parse(borderToggleFromSession) });
    }

    const whiteboardExtendFromSession = sessionStorage.getItem("whiteboardExtend");
    if (whiteboardExtendFromSession) {
      this.setState({ whiteboardExtend: getBooleanFromSession("whiteboardExtend") });
    }

    // For toggles that are booleans in session storage
    const toggles = ["flanT5Toggle", "anthropicToggle", "GrokAIToggle", "GeminiToggle", "completionToggle"];
    toggles.forEach(toggle => {
      const value = sessionStorage.getItem(toggle);
      if (value) {
        self.setState({ [toggle]: getBooleanFromSession(toggle) });
      }
    });

    // Set up auth state listener
    onAuthStateChanged(this.auth, (user) => {
      if (user) {
        const uid = user.uid;

        if (sessionStorage.getItem("openAiToggle") === "false") {
          this.setState({
            openAiToggle: false
          });
        } else if (sessionStorage.getItem("openAiToggle") === "true") {
          this.setState({
            openAiToggle: true
          });
        }
        this.setState({
          user: user,
          login: true,
        });
      } else {
        this.setState({
          login: false,
        });
      }
    });

    // Server-side only approach for initial session data
    const fetchSessionData = async () => {
      try {
        const baseURL = process.env.NODE_ENV === 'production'
          ? 'https://interview-sandbox-production.up.railway.app'
          : 'http://localhost:8000';

        const apiUrl = `${baseURL}/api/sessions/${sessionid}`;
        console.log('NODE_ENV:', process.env.NODE_ENV);
        console.log('baseURL:', baseURL);
        console.log('sessionid:', sessionid);
        console.log('Making API call to:', apiUrl);

        const response = await fetch(apiUrl);
        console.log('API response status:', response.status);
        console.log('API response ok:', response.ok);
        console.log('API response headers:', response.headers);

        if (!response.ok) {
          const errorText = await response.text();
          console.error('API error response:', errorText);
          throw new Error(`API request failed with status ${response.status}: ${errorText}`);
        }

        const sessionData = await response.json();
        console.log('API response data:', sessionData);

        // Get cursor position from Firebase
        const sessionRef = ref(this.db, `code-sessions/${sessionid}`);
        get(sessionRef).then((snapshot) => {
          if (snapshot.exists()) {
            const data = snapshot.val();
            const savedCursorPosition = data.cursorPosition;

            if (savedCursorPosition) {
              this.setState({ cursorPosition: savedCursorPosition }, () => {
                // Update CodeMirror with the content and cursor position
                if (self.codemirror && self.codemirror.getCodeMirror()) {
                  const cm = self.codemirror.getCodeMirror();
                  cm.setValue(sessionData.content || '');
                  cm.setCursor(savedCursorPosition);
                  // Ensure cursor is visible and focused
                  setTimeout(() => {
                    cm.focus();
                    cm.refresh(); // Refresh the editor to ensure cursor is visible
                    // Force cursor to be visible by moving it slightly and back
                    const { line, ch } = savedCursorPosition;
                    cm.setCursor({ line, ch: ch + 1 });
                    cm.setCursor(savedCursorPosition);
                  }, 100);
                }
              });
            } else {
              // If no saved cursor position, just set the content
              this.setState({
                code: sessionData.content || '',
                evalOutput: sessionData.evalOutput || undefined,
                compileOutput: sessionData.compileOutput || undefined,
                witeboard: "https://witeboard.com/" + sessionid,
                sessionid: sessionid,
              }, () => {
                if (self.codemirror && self.codemirror.getCodeMirror()) {
                  const cm = self.codemirror.getCodeMirror();
                  cm.setValue(sessionData.content || '');
                  // Ensure cursor is visible and focused even without saved position
                  setTimeout(() => {
                    cm.focus();
                    cm.refresh();
                    // Set cursor to end of content if no saved position
                    const lastLine = cm.lastLine();
                    const lastChar = cm.getLine(lastLine).length;
                    cm.setCursor({ line: lastLine, ch: lastChar });
                  }, 100);
                }
              });
            }
          }
        });

        this.setState({
          evalOutput: sessionData.evalOutput || undefined,
          compileOutput: sessionData.compileOutput || undefined,
          witeboard: "https://witeboard.com/" + sessionid,
          sessionid: sessionid,
        });

      } catch (error) {
        console.error("Server API error details:", {
          message: error.message,
          stack: error.stack,
          name: error.name
        });

        // Check if it's a network error vs server error
        if (error.name === 'TypeError' && error.message.includes('fetch')) {
          console.error("Network error - server might be down or CORS issue");
        }

        // Server-side only: no fallback to Firebase or sessionStorage
        // Set empty content and let user know server is required
        this.setState({
          code: '# Server unavailable. Please check your connection and try again.',
          evalOutput: undefined,
          compileOutput: undefined,
          witeboard: "https://witeboard.com/" + sessionid,
          sessionid: sessionid,
        }, () => {
          if (self.codemirror && self.codemirror.getCodeMirror()) {
            self.codemirror.getCodeMirror().setValue('# Server unavailable. Please check your connection and try again.');
          }
        });
      }
    };

    // Call the API function
    fetchSessionData();

    // Set up real-time listener for code changes BUT not for initial content loading
    // Only listen for changes AFTER initial server load is complete
    let initialContentLoaded = false;

    const sessionRef = ref(this.db, `code-sessions/${sessionid}`);
    onValue(sessionRef, (snapshot) => {
      if (snapshot.exists() && initialContentLoaded) {
        const data = snapshot.val();
        const content = data.content;
        const evalOutput = data.evalOutput;
        const compileOutput = data.compileOutput;
        const cursorPosition = data.cursorPosition;

        console.log("Firebase real-time update (after initial load):", { content, evalOutput, compileOutput, cursorPosition });

        // Only update if the content is different from current state
        if (content !== this.state.code) {
          this.setState(prevState => {
            const newState = {
              code: content,
              evalOutput: evalOutput || prevState.evalOutput,
              compileOutput: compileOutput || prevState.compileOutput,
            };

            // Only update cursor position if we're not currently typing
            // and the cursor position is different
            if (!this.isTyping && cursorPosition &&
              (cursorPosition.line !== prevState.cursorPosition.line ||
                cursorPosition.ch !== prevState.cursorPosition.ch)) {
              newState.cursorPosition = cursorPosition;
            }
            return newState;
          }, () => {
            if (self.codemirror && self.codemirror.getCodeMirror()) {
              const cm = self.codemirror.getCodeMirror();
              cm.setValue(content);

              // Only update cursor if we're not typing
              if (!this.isTyping && cursorPosition) {
                cm.setCursor(cursorPosition);
                setTimeout(() => {
                  cm.focus();
                  cm.refresh();
                }, 100);
              }
            }
          });
        }
      } else if (snapshot.exists() && !initialContentLoaded) {
        console.log("Firebase data exists but ignoring for initial load (server-side only)");
      }
    });

    // Set flag to allow Firebase updates after a short delay (server should have loaded by then)
    setTimeout(() => {
      initialContentLoaded = true;
      console.log("Now allowing Firebase real-time updates");
    }, 3000); // 3 second delay to ensure server load completes first

    this.updateUserSessionLastAccessed();
  }

  handleCodeChange(newVal) {
    if (!this.codemirror || !this.codemirror.getCodeMirror()) {
      return;
    }

    const dbRef = ref(this.db);
    const auth = getAuth();
    const user = auth.currentUser;

    if (this.state.isPrivate && user) {
      // Write to private-sandboxes for authenticated users
      update(child(dbRef, `private-sandboxes/${user.uid}/${this.state.sessionid}`), {
        content: newVal
      });
    } else {
      // Write to code-sessions for non-authenticated users or public sandboxes
      update(child(dbRef, `code-sessions/${this.state.sessionid}`), {
        content: newVal
      });
    }
  }

  updateAssistant(newVal) {
    if (!this.codemirror || !this.codemirror.getCodeMirror()) {
      return;
    }

    const dbRef = ref(this.db);
    const auth = getAuth();
    const user = auth.currentUser;

    if (this.state.isPrivate && user) {
      // Write to private-sandboxes for authenticated users
      return update(child(dbRef, `private-sandboxes/${user.uid}/${this.state.sessionid}`), {
        content: newVal
      });
    } else {
      // Write to code-sessions for non-authenticated users or public sandboxes
      return update(child(dbRef, `code-sessions/${this.state.sessionid}`), {
        content: newVal
      });
    }
  }

  handleKeyEvent(action, keyName) {
    this.setState({
      hotkeys: `${action} ${keyName}`,
    });
  }

  onKeyUp(keyName) {
    this.handleKeyEvent('onKeyUp', keyName);
  }

  onKeyDown(keyName) {
    this.handleKeyEvent('onKeyDown', keyName);
    this.runCode();
  }

  aiCompletion = () => {
    // Determine environment and return the corresponding URL
    const baseURL = process.env.NODE_ENV === 'production'
      ? 'https://interview-sandbox-production.up.railway.app'
      : 'http://localhost:8000';
    const { currlang, sessionid, code, suffix } = this.state;

    let evntSrtm = new EventSource(`${baseURL}/completion?language=${currlang}&sessionid=${sessionid}&code=${encodeURIComponent(code)}&suffix=${suffix}/`);

    evntSrtm.addEventListener("message", (event) => {
      // console.log("event: ", event.data, typeof event.data); 
      if (event.data === '[DONE]') {
        handleDoneEvent();
      } else if (event.data[0] === "d") {
        handleDStartEvent(event);
      } else {
        handleOtherEvent(event);
      }
    });

    const handleDoneEvent = () => {
      evntSrtm.close();
      this.setState({
        charCoords: this.codemirror.getCodeMirror().charCoords(this.state.cursorPosition)
      });
      const { line, ch } = this.state.cursorPosition;
      this.codemirror.getCodeMirror().doc.setCursor(line, ch);
      this.codemirror.getCodeMirror().doc.markText(this.state.cursorPosition, { line, ch: ch + this.state.codeSuggestion.length }, { className: "styled-background" });
    };

    const handleDStartEvent = (event) => {
      let spliced1stEvent = JSON.parse(event.data.substring(6));
      let splicedEvent2 = this.state.mode === "text/plain" ?
        spliced1stEvent.choices[0].text :
        spliced1stEvent.choices[0].delta.content;

      let newOutput = this.state.codeSuggestion + splicedEvent2;
      this.setState({
        codeSuggestion: newOutput
      });
    };

    const handleOtherEvent = (event) => {
      let newEvent = JSON.parse(event.data);
      if (newEvent.text === undefined) return;

      // Set the complete suggestion in state
      this.setState({ codeSuggestion: newEvent.text }, () => {
        // console.log("this.state.codeSuggestion after update: ", this.state.codeSuggestion);
      });

      // Remove previous suggestion mark (if any)
      const cm = this.codemirror.getCodeMirror();
      cm.getAllMarks().forEach(marker => marker.clear());

      // Get current cursor position
      const { line, ch } = this.state.cursorPosition;

      // Clear any existing suggestion text
      const currentText = cm.getRange(
        { line, ch },
        { line, ch: ch + (this.state.codeSuggestion ? this.state.codeSuggestion.length : 0) }
      );
      if (currentText) {
        cm.replaceRange("", { line, ch }, { line, ch: ch + currentText.length });
      }

      // Insert the complete text
      cm.replaceRange(newEvent.text, { line, ch });

      // Mark the entire suggestion
      cm.markText(
        { line, ch },
        { line, ch: ch + newEvent.text.length },
        { className: "styled-background" }
      );
    };


    evntSrtm.addEventListener("error", (error) => {
      console.log(error);
    });
  }

  useHuggingFace = async () => {
    const baseURL = process.env.NODE_ENV === "development"
      ? "http://localhost:8000"
      : "https://interview-sandbox-production.up.railway.app";

    const codeInput = this.state.code;
    const hfURL = `${baseURL}/huggingface?language=${this.state.currlang}&sessionid=${this.state.sessionid}&code=${encodeURIComponent(codeInput)}/`;

    const response = await fetch(hfURL, { method: "GET" });
    const data = await response.text();

    this.processData(data);
    this.startCardRender();
  }


  processData = (data) => {
    const newCardAdded = [{
      output: data.split(""),
      time: new Date().toLocaleString(),
      model: "hf"
    }];
    this.setState({ cardsHF: newCardAdded });
  }

  startCardRender = () => {
    const cardRender = setInterval(() => {
      const cardsHF = this.state.cardsHF;
      if (!cardsHF[0] || cardsHF[0].output.length === 0) {
        clearInterval(cardRender);
        this.setState({ cardsHF: [] });
        return;
      }
      this.updateCards();
    }, 10);
  }

  updateCards = () => {
    const cards = this.state.cards;
    const cardsHF = this.state.cardsHF;
    const code = cardsHF[0].output;
    const time = cardsHF[0].time;

    if (!cards[0] || cards[0].time !== time) {
      cards.unshift({ output: [], time: undefined, model: undefined });
    }

    const outputSnippet = code.slice(0, 1);
    const newCards = [{
      output: (cards[0].output || []).concat(outputSnippet),
      time: time,
      model: "hf"
    }, ...cards.slice(1)];

    const newCards2 = [{
      output: code.slice(1),
      time: time,
      model: "hf"
    }, ...cardsHF.slice(1)];

    this.setState({
      cards: newCards,
      cardsHF: newCards2
    });
  }

  useGemini = async () => {
    const baseURL = process.env.NODE_ENV === "development"
      ? "http://localhost:8000"
      : "https://interview-sandbox-production.up.railway.app";
    const codeInput = this.state.code;

    const geminiURL = `${baseURL}/gemini?language=${this.state.currlang}&sessionid=${this.state.sessionid}&code=${encodeURIComponent(codeInput)}/`;

    const handleResponse = async (response) => {
      const data = await response.text();
      const newCardAdded = [{
        "output": data.split(""),
        "time": new Date().toLocaleString(),
        "model": "Google Gemini"
      }];
      this.setState({ cardsGemini: newCardAdded });
    }

    const fetchGemini = async () => {
      const response = await fetch(geminiURL, { method: "GET" });
      await handleResponse(response);
    }

    const renderCard = () => {
      if (typeof (this.state.cardsGemini[0]) === 'undefined') {
        return;
      }
      else if (this.state.cardsGemini[0].output.length === 0) {
        clearInterval(cardRender, 1000);
        this.setState({ cardsGemini: [] });
      }
      else if (this.state.cardsGemini[0].output.length > 0) {
        if (!this.state.cards[0]) {
          this.state.cards.unshift({ "output": [], "time": undefined, "model": undefined });
        }
        if (this.state.cards[0].time !== this.state.cardsGemini[0].time && this.state.cards[0].time !== undefined) {
          this.state.cards.unshift({ "output": [], "time": undefined, "model": undefined });
        }
        const code = this.state.cardsGemini[0].output;
        const time = this.state.cardsGemini[0].time;
        const cardsGeminiOutput = code.slice(1,);
        const outputSnippet = code.slice(0, 1);
        const newCards = [{ "output": this.state.cards[0].output.concat(outputSnippet), "time": time, "model": "Google Gemini" }, ...this.state.cards.slice(1,)];
        const newCards2 = [{ "output": cardsGeminiOutput, "time": time, "model": "Google Gemini" }, ...this.state.cardsGemini.slice(1,)];
        this.setState({
          cards: newCards,
          cardsGemini: newCards2
        });
      }
    }

    await fetchGemini();

    const cardRender = setInterval(renderCard, 1);
  }


  usePaLM = async () => {
    const baseURL = process.env.NODE_ENV === "development"
      ? "http://localhost:8000"
      : "https://interview-sandbox-production.up.railway.app";
    const codeInput = this.state.code;

    const palmURL = `${baseURL}/palm?language=${this.state.currlang}&sessionid=${this.state.sessionid}&code=${encodeURIComponent(codeInput)}/`;

    const handleResponse = async (response) => {
      const data = await response.text();
      const newCardAdded = [{
        "output": data.split(""),
        "time": new Date().toLocaleString(),
        "model": "Google PaLM"
      }];
      this.setState({ cardsPaLM: newCardAdded });
    }

    const fetchPaLM = async () => {
      const response = await fetch(palmURL, { method: "GET" });
      await handleResponse(response);
    }

    const renderCard = () => {
      if (typeof (this.state.cardsPaLM[0]) === 'undefined') {
        return;
      }
      else if (this.state.cardsPaLM[0].output.length === 0) {
        clearInterval(cardRender, 1000);
        this.setState({ cardsPaLM: [] });
      }
      else if (this.state.cardsPaLM[0].output.length > 0) {
        if (!this.state.cards[0]) {
          this.state.cards.unshift({ "output": [], "time": undefined, "model": undefined });
        }
        if (this.state.cards[0].time !== this.state.cardsPaLM[0].time && this.state.cards[0].time !== undefined) {
          this.state.cards.unshift({ "output": [], "time": undefined, "model": undefined });
        }
        const code = this.state.cardsPaLM[0].output;
        const time = this.state.cardsPaLM[0].time;
        const cardsPaLMOutput = code.slice(1,);
        const outputSnippet = code.slice(0, 1);
        const newCards = [{ "output": this.state.cards[0].output.concat(outputSnippet), "time": time, "model": "Google PaLM" }, ...this.state.cards.slice(1,)];
        const newCards2 = [{ "output": cardsPaLMOutput, "time": time, "model": "Google PaLM" }, ...this.state.cardsPaLM.slice(1,)];
        this.setState({
          cards: newCards,
          cardsPaLM: newCards2
        });
      }
    }

    await fetchPaLM();

    const cardRender = setInterval(renderCard, 1);
  }

  useAnthropic = () => {
    const baseURL = process.env.NODE_ENV === "development"
      ? "http://localhost:8000"
      : "https://interview-sandbox-production.up.railway.app";

    let codeInput = this.state.code;

    // Create a new card for this request
    const newCard = {
      output: [],
      time: new Date().toLocaleString(),
      model: "anthropic"
    };

    // Add the new card to the top of the stack
    this.setState(prevState => ({
      cards: [newCard, ...prevState.cards]
    }));

    // Start the EventSource connection
    const eventStream = new EventSource(`${baseURL}/anthropic?language=${this.state.currlang}&sessionid=${this.state.sessionid}&code=${encodeURIComponent(codeInput)}/`);

    eventStream.addEventListener("message", (event) => {
      try {
        const eventData = JSON.parse(event.data);
        if (eventData.text) {
          this.setState(prevState => {
            const currentCards = [...prevState.cards];
            // Update the first card (most recent) with new content
            currentCards[0] = {
              ...currentCards[0],
              output: [...currentCards[0].output, eventData.text]
            };
            return { cards: currentCards };
          });
        }
      } catch (error) {
        console.error('Error processing Anthropic response:', error);
      }
    });

    eventStream.addEventListener("error", (error) => {
      console.error('EventStream Error:', error);
      eventStream.close();
    });

    // Clean up when component unmounts
    return () => {
      eventStream.close();
    };
  };

  useOpenAI = () => {
    const baseURL = process.env.NODE_ENV === "development"
      ? "http://localhost:8000"
      : "https://interview-sandbox-production.up.railway.app";

    let codeInput = this.state.code;

    let evntSrtm = new EventSource(`${baseURL}/openai?language=${this.state.currlang}&sessionid=${this.state.sessionid}&code=${encodeURIComponent(codeInput)}/`);

    evntSrtm.onopen = () => {
      // Create initial card
      this.setState(prevState => ({
        cards: [{
          output: "",
          time: new Date().toLocaleString(),
          model: "openai"
        }, ...(prevState.cards || [])]
      }));
    };

    evntSrtm.addEventListener("message", (event) => {
      const { data } = event;

      if (data === '[DONE]') {
        evntSrtm.close();
        return;
      }

      try {
        const parsedData = JSON.parse(data);
        if (parsedData.text) {
          this.setState(prevState => {
            const currentCards = [...prevState.cards];
            if (currentCards.length === 0) {
              currentCards.push({
                output: parsedData.text,
                time: new Date().toLocaleString(),
                model: "openai"
              });
            } else {
              currentCards[0] = {
                ...currentCards[0],
                output: (currentCards[0].output || "") + parsedData.text
              };
            }
            return { cards: currentCards };
          });
        }
      } catch (error) {
        console.error('Error parsing OpenAI response:', error);
      }
    });

    evntSrtm.addEventListener("error", (error) => {
      console.error('EventSource error:', error);
      evntSrtm.close();
    });
  };

  closeCard(index) {
    if (index > -1) {
      const newCards = [...this.state.cards];
      newCards.splice(index, 1);
      this.setState({ cards: newCards });
    }
  }

  copyCard(index) {
    const cardCopy = this.state.cards[index].output.join("");
    navigator.clipboard.writeText(cardCopy);
    return (
      <div>
        <p>copied to clipboard</p>
      </div>
    );
  }


  mapCards() {
    const { cards } = this.state;
    const { darkMode } = this.props;

    const cardInfo = cards.map((card, index) => (
      <Card
        key={index}
        index={index}
        output={card.output}
        cardCreated={card.time}
        model={card.model}
        darkMode={darkMode}
        closeCard={this.closeCard}
        copyCard={this.copyCard}
      />
    ));

    return (
      <RemoveScroll className="poweredBy scroll">
        <div className="cards-container">
          {cardInfo}
        </div>
        <div ref={this.cardsEndRef} />
      </RemoveScroll>
    );
  }


  poweredBy() {
    if (this.state.cards.length && this.state.currlang !== " plntxt") {
      return <div>
        {/* <div className="poweredBy">Usage: </div> */}
        {/* <div className="poweredBy">Completion {this.state.usage.completion_tokens}</div>
        <div className="poweredBy">Prompt {this.state.usage.prompt_tokens}</div>
        <div className="poweredBy">Total {this.state.usage.total_tokens}</div> */}
        <div className="codex poweredBy neonText">Codex</div>
      </div>
    } else if (this.state.cards.length && this.state.currlang === " plntxt") {
      return <div>
        {/* <div className="poweredBy">Usage: </div> */}
        {/* <div className="poweredBy">Completion {this.state.usage.completion_tokens}</div>
        <div className="poweredBy">Prompt {this.state.usage.prompt_tokens}</div>
        <div className="poweredBy">Total {this.state.usage.total_tokens}</div> */}
        <div className="codex poweredBy neonText">GPT-3</div>
      </div>
    }
  };

  // The Judge0 API is used to evaluste the users code,
  // there are two steps to that. 1-A code submission (POST request) is
  // made, and the response is a token. Then that token is used in a GET
  // request to return the result of the code execution. I split this
  // between the runCode() and useToken functions.
  async runCode() {
    // Use throttled version for public sandboxes
    if (!this.state.isPrivate && !this.state.login) {
      this.runCodeThrottle();
      return;
    }

    this.setState({ loading: true });
    const baseURL = process.env.NODE_ENV === "development"
      ? "http://localhost:8000"
      : "https://interview-sandbox-production.up.railway.app";

    const handleResponseData = (data) => {
      let sessionid2 = this.state.sessionid;
      this.setState({ history: Object.assign(this.state.history, { [sessionid2]: new Date().toLocaleString() }) });
      localStorage.setItem("history", JSON.stringify(this.state.history));
      localStorage.setItem("prevBoard", JSON.stringify(this.state.sessionid));

      if (data.stdout) {
        let evalOutput = data.stdout;
        let compileOutput = data.compile_output;
        let errOut = data.stderr;
        let time = data.time;
        let memory = data.memory;

        const updatedState = errOut == null
          ? { evalOutput: evalOutput, compileOutput: compileOutput, errOut: errOut, loading: false, time: time, memory: memory }
          : { evalOutput: evalOutput + errOut, compileOutput: compileOutput, loading: false };

        this.setState(updatedState, () => {
          // console.log("State after runCode update:", this.state.evalOutput);
        });

        sessionStorage.setItem("evalOutput", evalOutput);
        sessionStorage.setItem("compileOutput", compileOutput);
        sessionStorage.setItem("errOut", errOut);

        const dbRef = ref(this.db);
        const auth = getAuth();
        const user = auth.currentUser;

        if (this.state.isPrivate && user) {
          // Write to private-sandboxes for authenticated users
          update(child(dbRef, `private-sandboxes/${user.uid}/${this.state.sessionid}`), {
            evalOutput: "" + this.state.evalOutput,
            compileOutput: "" + this.state.compileOutput,
          });
        } else {
          // Write to code-sessions for non-authenticated users or public sandboxes
          update(child(dbRef, `code-sessions/${this.state.sessionid}`), {
            evalOutput: "" + this.state.evalOutput,
            compileOutput: "" + this.state.compileOutput,
          });
        }
      } else if (data.stdout == null) {
        let errOut = data.stderr;
        let time = data.time;
        let memory = data.memory;

        console.log("Setting error output:", errOut);

        this.setState(prevState => ({
          evalOutput: errOut,
          loading: false,
          time: time,
          memory: memory,
          compileOutput: prevState.compileOutput
        }), () => {
          console.log("State after error update:", this.state.evalOutput);
        });
      }
    }

    if (this.state.openAiToggle) this.useOpenAI();
    if (this.state.flanT5Toggle) this.useHuggingFace();
    if (this.state.anthropicToggle) this.useAnthropic();
    if (this.state.GrokAIToggle) this.useGrokAI();
    if (this.state.GeminiToggle) this.useGemini();

    const judge0URL = `${baseURL}/judge0?language_id=${this.state.language_id}&sessionid=${this.state.sessionid}&code=${encodeURIComponent(this.state.code)}`;

    try {
      const response = await fetch(judge0URL, {
        method: "GET",
        params: { base64_encoded: 'true', fields: '*' },
      });
      const data = await response.json();
      handleResponseData(data);
    } catch (err) {
      console.log(err);
      this.setState({ loading: false });
    }

    this.updateUserSessionLastAccessed();
  }


  toggleExtend() {
    this.setState(prevState => ({ evalExtend: !prevState.evalExtend }));
  }


  toggleTimer() {
    this.setState(prevState => ({ timerExtend: !prevState.timerExtend }));
  }


  toggleWhiteboard() {
    const newWhiteboardExtendValue = !this.state.whiteboardExtend;

    this.setState({ whiteboardExtend: newWhiteboardExtendValue });
    sessionStorage.setItem("whiteboardExtend", newWhiteboardExtendValue.toString());
  }

  toggleBorder() {
    const newBorderToggleValue = !this.state.borderToggle;
    this.setState({ borderToggle: newBorderToggleValue });
    sessionStorage.setItem("borderToggle", newBorderToggleValue.toString());
  }

  toggleOpenAI() {
    const newOpenAiToggleValue = !this.state.openAiToggle;

    this.setState({ openAiToggle: newOpenAiToggleValue });
    sessionStorage.setItem("openAiToggle", newOpenAiToggleValue.toString());
  }


  toggleCompletion() {
    const newCompletionToggleValue = !this.state.completionToggle;
    this.setState({ completionToggle: newCompletionToggleValue });
    sessionStorage.setItem("completionToggle", newCompletionToggleValue.toString());
  }


  toggleFlanT5() {
    const newFlanT5ToggleValue = !this.state.flanT5Toggle;

    this.setState({ flanT5Toggle: newFlanT5ToggleValue });
    sessionStorage.setItem("flanT5Toggle", newFlanT5ToggleValue.toString());
  }


  toggleAnthropic() {
    const newAnthropicToggleValue = !this.state.anthropicToggle;

    this.setState({ anthropicToggle: newAnthropicToggleValue });
    sessionStorage.setItem("anthropicToggle", newAnthropicToggleValue.toString());
  }

  togglePaLM() {
    const newPaLMToggleValue = !this.state.PaLMToggle;
    this.setState({ PaLMToggle: newPaLMToggleValue });
    sessionStorage.setItem("PaLMToggle", newPaLMToggleValue.toString());
  }

  toggleGemini() {
    const newGeminiToggleValue = !this.state.GeminiToggle;

    this.setState({ GeminiToggle: newGeminiToggleValue });
    sessionStorage.setItem("GeminiToggle", newGeminiToggleValue.toString());
  }

  toggleGrokAI() {
    const newGrokAIToggleValue = !this.state.GrokAIToggle;
    this.setState({ GrokAIToggle: newGrokAIToggleValue });
    sessionStorage.setItem("GrokAIToggle", newGrokAIToggleValue.toString());
  }


  // toggleBorder() {
  //   const newBorderToggleValue = !this.state.borderToggle;

  //   this.setState({ borderToggle: newBorderToggleValue });
  //   sessionStorage.setItem("borderToggle", newBorderToggleValue.toString());
  // }


  //Lets you select between JS, Python, Ruby
  toggleLanguage(id, key, mode) {
    // Shallow copy of the array/object from state using the key
    const temp = Array.isArray(this.state[key]) ? [...this.state[key]] : { ...this.state[key] };

    temp[id].selected = !temp[id].selected;
    const newMode = temp[id];
    const { mode: newModeMode, language_id, title } = newMode;

    this.setState({
      [key]: temp,
      mode: newModeMode,
      language_id,
      currlang: title,
    });

    // Store in sessionStorage
    sessionStorage.setItem(key, JSON.stringify(temp));
    sessionStorage.setItem("mode", newModeMode);
    sessionStorage.setItem("language_id", language_id.toString());
    sessionStorage.setItem("currlang", title);

    // Store in Firebase if we have a session
    if (this.state.sessionid) {
      const dbRef = ref(this.db);
      const auth = getAuth();
      const user = auth.currentUser;

      if (this.state.isPrivate && user) {
        // Write to private-sandboxes for authenticated users
        update(child(dbRef, `private-sandboxes/${user.uid}/${this.state.sessionid}`), {
          language: title,
          language_id: language_id,
          mode: newModeMode
        });
      } else {
        // Write to code-sessions for non-authenticated users or public sandboxes
        update(child(dbRef, `code-sessions/${this.state.sessionid}`), {
          language: title,
          language_id: language_id,
          mode: newModeMode
        });
      }
    }
  }


  //To keep track of where the cursor is currently
  changeCursorPos = () => {
    const { line, ch } = this.state.cursorPosition;
    this.codemirror.getCodeMirror().doc.setCursor(line, ch);
  };

  //This is where the code editor handles changes from user input
  onChange = (newVal, change) => {
    if (!this.codemirror || !this.codemirror.getCodeMirror()) {
      return;
    }

    const cm = this.codemirror.getCodeMirror();
    const doc = cm.doc;

    // Set typing flag
    this.isTyping = true;
    clearTimeout(this.typingTimeout);
    this.typingTimeout = setTimeout(() => {
      this.isTyping = false;
    }, 1000); // Consider typing finished after 1 second of no changes

    if (!change.origin) {
      this.setState({ charCoords: undefined });
      return;
    }

    const suffix = cm.getRange(doc.getCursor(), {
      line: doc.lineCount(),
      ch: 0
    });

    const newState = {
      suffix,
      code: newVal
    };

    if (this.state.completionToggle) {
      newState.codeSuggestion = "";
      clearTimeout(this.inputTimer);
      this.inputTimer = setTimeout(() => {
        this.aiCompletion();
      }, 1500);
    }

    this.setState(newState);

    // Debounce Firebase updates during typing
    clearTimeout(this.firebaseUpdateTimeout);
    this.firebaseUpdateTimeout = setTimeout(() => {
      const dbRef = ref(this.db);
      const auth = getAuth();
      const user = auth.currentUser;

      if (this.state.isPrivate && user) {
        // Write to private-sandboxes for authenticated users
        update(child(dbRef, `private-sandboxes/${user.uid}/${this.state.sessionid}`), {
          content: newVal
        });
      } else {
        // Write to code-sessions for non-authenticated users or public sandboxes
        update(child(dbRef, `code-sessions/${this.state.sessionid}`), {
          content: newVal
        });
      }
    }, 500);
  };

  whiteboardRender() {
    const whiteboardExtendFromState = this.state.whiteboardExtend;
    const whiteboardExtendFromSession = sessionStorage.getItem("whiteboardExtend") === "true";
    const borderToggleFromState = this.state.borderToggle;
    const borderToggleFromSession = sessionStorage.getItem("borderToggle") === "true";
    const darkMode = this.props.darkMode;

    if (whiteboardExtendFromState || whiteboardExtendFromSession) {
      let handleWrapperClass = "";

      if (borderToggleFromState || borderToggleFromSession) {
        handleWrapperClass = darkMode ? "borderOn-dark" : "borderOn";
      } else {
        handleWrapperClass = darkMode ? "handleToggle-dark" : "handleToggle";
      }

      return (
        <div>
          <Resizable
            handleWrapperClass={handleWrapperClass}
            enable={{ left: true }}
            minWidth="40vw"
            maxWidth="69vw"
          >
            <RemoveScroll>
              <iframe
                title="Witeboard"
                className="witeboard"
                src={this.state.witeboard}
              ></iframe>
            </RemoveScroll>
          </Resizable>
        </div>
      );
    }
  }

  login() {
    this.props.navigate("/login");
  };

  logout() {
    const auth = getAuth();
    signOut(auth).then(() => {
      // Sign-out successful.
      this.setState({
        login: false,
      })
      console.log("logout");
    }).catch((error) => {
      // An error happened.
    });
  }

  loginRender() {
    const { login } = this.state;
    const iconStyle = {
      size: "1.35em",
      style: {
        paddingRight: "0.2rem",
        marginTop: "0.1rem",
        position: "fixed",
        top: "11px",
        right: "1%"
      }
    };

    return (
      <div
        className="loginBtn"
        title={login ? "logout" : "login"}
        onClick={login ? this.logout.bind(this) : this.login.bind(this)}
      >
        <IconContext.Provider value={iconStyle}>
          {login ? <CiLogout /> : <CiLogin />}
        </IconContext.Provider>
      </div>
    );
  }


  toolTipRender() {
    if (this.state.charCoords) {
      if (this.codemirror.getCodeMirror().doc.getAllMarks().length > 0) {
        return <div className="tooltip" style={{ top: this.codemirror.getCodeMirror().heightAtLine(this.state.cursorPosition.line) - 4.2, left: this.state.charCoords.left }}>
          <div className="tooltip-text">
            <div className="tooltip-shift-tab tooltip-text" onClick={this.acceptSuggestion.bind(this)}>
              SHIFT + TAB to Accept |
            </div>
            <div className="tooltip-escape tooltip-text" onClick={this.denySuggestion.bind(this)}>
              | ESC to Deny
            </div>
          </div>
        </div>
      }
    }
  }

  acceptSuggestion() {
    const { line, ch } = this.state.cursorPosition;
    const codeSuggestionLength = this.state.codeSuggestion;
    const codeMirrorInstance = this.codemirror.getCodeMirror().doc;
    codeMirrorInstance.getAllMarks().forEach(marker => marker.clear())
    codeMirrorInstance.setCursor(line, ch + codeSuggestionLength.length)
  }


  denySuggestion() {
    const { cursorPosition: { line, ch }, codeSuggestion } = this.state;
    const codeMirrorInstance = this.codemirror.getCodeMirror().doc;
    this.setState({ charCoords: undefined });
    const fromPos = { line, ch };
    const toPos = { line, ch: ch + codeSuggestion.length };
    codeMirrorInstance.replaceRange("", fromPos, toPos);
  }

  updateTranscript = (newTranscript) => {
    if (newTranscript !== "") {
      console.log("transcript in state: ", newTranscript);

      this.setState((prevState) => {
        const updatedCards = [...prevState.cards];

        // Check if the previous card's model is 'assistant'
        if (updatedCards.length > 0 && updatedCards[0].model === 'assistant') {
          // Add the new transcript with highlight and ensure a new line is at the end
          updatedCards[0].output.push(`<span class="highlight">${newTranscript}</span>\n\n`);
        } else {
          // Create a new card with the transcript data, highlight, and a line break
          const newCard = {
            output: [`<span class="highlight">${newTranscript}</span>\n\n`],
            time: new Date().toLocaleString(),
            model: 'assistant',
          };
          // Add the new card to the existing cards
          updatedCards.unshift(newCard);
        }

        return { cards: updatedCards };
      }, this.scrollToBottom);
    }
  };

  scrollToBottom() {
    if (this.cardsEndRef.current) {
      this.cardsEndRef.current.scrollIntoView({ behavior: "smooth" });
    }
  }

  useGrokAI = () => {
    const baseURL = process.env.NODE_ENV === "development"
      ? "http://localhost:8000"
      : "https://interview-sandbox-production.up.railway.app";

    let codeInput = this.state.code;

    let evntSrtm = new EventSource(`${baseURL}/grok?language=${this.state.currlang}&sessionid=${this.state.sessionid}&code=${encodeURIComponent(codeInput)}/`);

    evntSrtm.onopen = () => {
      // console.log('Grok AI EventSource connection opened');
    };

    evntSrtm.addEventListener("message", (event) => {
      const { data } = event;
      // console.log("Grok AI data: ", data);

      if (data === '[DONE]') {
        evntSrtm.close();
        return;
      }

      try {
        const parsedData = JSON.parse(data);

        if (parsedData.type === "new_card") {
          // Create a new card
          this.setState(prevState => ({
            cards: [{
              output: "",
              time: new Date().toLocaleString(),
              model: "Grok AI"
            }, ...prevState.cards]
          }));
        } else if (parsedData.type === "update_card" && parsedData.content) {
          // Update the existing card
          this.setState(prevState => {
            if (prevState.cards.length === 0) return prevState;

            const currentCards = [...prevState.cards];
            currentCards[0] = {
              ...currentCards[0],
              output: (currentCards[0].output || "") + parsedData.content
            };

            return { cards: currentCards };
          });
        } else if (parsedData.type === "error") {
          console.error("Grok AI Error:", parsedData.error, parsedData.details);
        }
      } catch (error) {
        console.error('Error parsing Grok AI response:', error);
      }
    });

    evntSrtm.addEventListener("error", (error) => {
      console.error('Grok AI EventSource error:', error);
      evntSrtm.close();
    });
  };

  updateUserSessionLastAccessed = () => {
    const auth = getAuth();
    const user = auth.currentUser;
    const db = getDatabase();
    const sessionId = this.state.sessionid;
    if (user && sessionId) {
      const userId = user.uid;
      if (this.state.isPrivate) {
        // Update lastAccessed in private-sandboxes
        update(ref(db, `private-sandboxes/${userId}/${sessionId}/lastAccessed`), {
          lastAccessed: new Date().toLocaleString()
        });
      } else {
        // Update lastAccessed in code-sessions
        update(ref(db, `code-sessions/${sessionId}/lastAccessed`), {
          lastAccessed: new Date().toLocaleString()
        });
      }
    }
  };

  // Anti-abuse methods
  checkAbuseLimits() {
    const now = Date.now();
    const oneMinute = 60 * 1000;

    // Check for excessive code runs (only for public sandboxes)
    if (!this.state.isPrivate && !this.state.login) {
      if (now - this.state.lastRunTime < oneMinute) {
        this.setState(prevState => ({ runCount: prevState.runCount + 1 }));

        if (this.state.runCount > 8) { // Warn at 8 runs per minute
          this.showAbuseWarning('You\'re running code very frequently. Consider slowing down or signing up for higher limits.');
          return false;
        }
      } else {
        this.setState({ runCount: 1, lastRunTime: now });
      }
    }

    return true;
  }

  showAbuseWarning(message) {
    this.setState({ abuseWarning: message });

    // Clear warning after 5 seconds
    setTimeout(() => {
      this.setState({ abuseWarning: null });
    }, 5000);
  }

  runCodeThrottle() {
    if (!this.checkAbuseLimits()) {
      return;
    }

    // Proceed with normal runCode
    this.runCode();
  }

  // Share functionality methods
  generateShareLink() {
    const baseURL = window.location.origin;
    const sessionId = this.state.sessionid;

    if (this.state.isPrivate && this.state.login) {
      // For private sandboxes, include user info
      const auth = getAuth();
      const user = auth.currentUser;
      return `${baseURL}/coding/${sessionId}?private=1&user=${user.uid}`;
    } else {
      // For public sandboxes
      return `${baseURL}/coding/${sessionId}`;
    }
  }

  openShareModal() {
    const shareLink = this.generateShareLink();
    this.setState({
      showShareModal: true,
      shareLink: shareLink,
      copySuccess: false
    });
  }

  closeShareModal() {
    this.setState({
      showShareModal: false,
      shareLink: "",
      copySuccess: false
    });
  }

  async copyToClipboard() {
    try {
      await navigator.clipboard.writeText(this.state.shareLink);
      this.setState({ copySuccess: true });

      // Reset success message after 2 seconds
      setTimeout(() => {
        this.setState({ copySuccess: false });
      }, 2000);
    } catch (err) {
      console.error('Failed to copy: ', err);
      // Fallback for older browsers
      const textArea = document.createElement('textarea');
      textArea.value = this.state.shareLink;
      document.body.appendChild(textArea);
      textArea.select();
      document.execCommand('copy');
      document.body.removeChild(textArea);

      this.setState({ copySuccess: true });
      setTimeout(() => {
        this.setState({ copySuccess: false });
      }, 2000);
    }
  }

  async togglePrivacy() {
    const auth = getAuth();
    const user = auth.currentUser;

    if (!user) {
      alert('You must be logged in to make sandboxes private');
      return;
    }

    const dbRef = ref(this.db);
    const sessionId = this.state.sessionid;
    const userId = user.uid;

    try {
      if (this.state.isPrivate) {
        // Convert from private to public
        // First, get the private sandbox data
        const privateSnapshot = await get(ref(this.db, `private-sandboxes/${userId}/${sessionId}`));
        if (privateSnapshot.exists()) {
          const privateData = privateSnapshot.val();

          // Copy to public sandboxes
          await set(ref(this.db, `code-sessions/${sessionId}`), {
            ...privateData,
            convertedFromPrivate: true,
            originalOwner: userId
          });

          // Remove from private sandboxes
          await remove(ref(this.db, `private-sandboxes/${userId}/${sessionId}`));

          // Update state
          this.setState({ isPrivate: false });

          // Update share link
          this.generateShareLink();
        }
      } else {
        // Convert from public to private
        // First, get the public sandbox data
        const publicSnapshot = await get(ref(this.db, `code-sessions/${sessionId}`));
        if (publicSnapshot.exists()) {
          const publicData = publicSnapshot.val();

          // Copy to private sandboxes
          await set(ref(this.db, `private-sandboxes/${userId}/${sessionId}`), {
            ...publicData,
            convertedFromPublic: true,
            convertedAt: new Date().toLocaleString()
          });

          // Remove from public sandboxes
          await remove(ref(this.db, `code-sessions/${sessionId}`));

          // Update state
          this.setState({ isPrivate: true });

          // Update share link
          this.generateShareLink();
        }
      }
    } catch (error) {
      console.error('Error toggling privacy:', error);
      alert('Failed to change privacy setting. Please try again.');
    }
  }

  render() {
    initializeAnalytics();
    // eslint-disable-next-line  
    let usageStats = this.state.usage;
    // eslint-disable-next-line
    let codeSuggestion = this.state.code + this.state.codeSuggestion;
    const { line, ch } = this.state.cursorPosition;
    let codeSuggestionLength = this.state.codeSuggestion;
    return (
      <RemoveScroll>
        <React.Fragment>
          <Hotkeys
            keyName="command+enter,alt+s,command+i"
            onKeyDown={(keyName) => {
              if (keyName === "command+i") {
                this.toggleCompletion();
              } else if (keyName === "command+enter" || keyName === "alt+s") {
                this.onKeyDown(keyName);
              }
            }}
            onKeyUp={this.onKeyUp.bind(this)}
          >
            <meta name="viewport" content="width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=0" />
            <Header
              darkMode={this.props.darkMode}
              // style={{ background: "#282a36" }}
              extras={
                <div className="createdOn">
                  {this.state.createdon
                    ? `${this.state.createdon}`
                    : ""}
                </div>
              }
            />
            {this.loginRender()}
            {this.toolTipRender()}
            <History darkMode={this.props.darkMode} />
            {this.state.abuseWarning && (
              <div className="abuse-warning">
                <div className="abuse-warning-content">
                  <span className="abuse-warning-icon">⚠️</span>
                  <span className="abuse-warning-text">{this.state.abuseWarning}</span>
                </div>
              </div>
            )}
            {this.state.showShareModal && (
              <div className="share-modal-overlay" onClick={this.closeShareModal}>
                <div className="share-modal" onClick={(e) => e.stopPropagation()}>
                  <div className="share-modal-header">
                    <h3>🔗 Share Sandbox</h3>
                    <button className="share-modal-close" onClick={this.closeShareModal}>×</button>
                  </div>
                  <div className="share-modal-content">
                    <div className="share-link-section">
                      <label>Shareable Link:</label>
                      <div className="share-link-container">
                        <input
                          type="text"
                          value={this.state.shareLink}
                          readOnly
                          className="share-link-input"
                        />
                        <button
                          className="copy-link-btn"
                          onClick={this.copyToClipboard}
                        >
                          {this.state.copySuccess ? '✓ Copied!' : '📋 Copy'}
                        </button>
                      </div>
                    </div>
                    <div className="share-info">
                      <p>
                        {this.state.isPrivate ?
                          "🔒 Private sandbox - Only you can edit, others can view and fork" :
                          "🌐 Public sandbox - Anyone can view and fork"
                        }
                      </p>
                    </div>
                    {this.state.login && (
                      <div className="privacy-toggle-section">
                        <label>Privacy Setting:</label>
                        <div className="privacy-toggle-container">
                          <button
                            className={`privacy-toggle-btn ${!this.state.isPrivate ? 'active' : ''}`}
                            onClick={() => !this.state.isPrivate ? null : this.togglePrivacy()}
                            disabled={!this.state.isPrivate}
                          >
                            🌐 Public
                          </button>
                          <button
                            className={`privacy-toggle-btn ${this.state.isPrivate ? 'active' : ''}`}
                            onClick={() => this.state.isPrivate ? null : this.togglePrivacy()}
                            disabled={this.state.isPrivate}
                          >
                            🔒 Private
                          </button>
                        </div>
                        <p className="privacy-note">
                          {this.state.isPrivate ?
                            "Private sandboxes are only visible to you and can be shared with others for viewing." :
                            "Public sandboxes are visible to everyone and can be accessed by anyone with the link."
                          }
                        </p>
                      </div>
                    )}
                  </div>
                </div>
              </div>
            )}
            <div className={this.state.whiteboardExtend === false ? "topMost-whiteboard" : "topMost"}>
              <div className="coding">
                <div className="topHalf">
                  <div className={this.state.whiteboardExtend === false ? "coding-page" : "coding-page-whiteboard"}>
                    {/* This is where the CODE EDITOR goes */}
                    <CodeMirror
                      ref={(r) => (this.codemirror = r)}
                      style={{ backgroundColor: this.props.darkMode === false ? '#282a36' : '#000' }}
                      className={this.props.darkMode === false ? "CodeMirror-theme code-mirror-container" : "CodeMirror-theme-dark code-mirror-container"}
                      value={this.state.code}
                      onChange={this.onChange}
                      options={{
                        theme: "dracula",
                        lineNumbers: true,
                        lineWrapping: true,
                        tabMode: "indent",
                        matchBrackets: true,
                        matchTags: true,
                        autoCloseTags: true,
                        autoCloseBrackets: true,
                        readOnly: false,
                        scrollbarStyle: "null",
                        mode: this.state.mode,
                        autofocus: true,
                        indentWithTabs: true,
                        smartIndent: true,
                        cursorBlinkRate: 530, // Make cursor blink at a visible rate
                        cursorHeight: 1, // Make cursor full height
                        cursorStyle: "line", // Use a line cursor
                        extraKeys: {
                          "Shift-Tab": (cm) => {
                            cm.doc.getAllMarks().forEach(marker => marker.clear());
                            cm.doc.setCursor(this.state.cursorPosition.line, this.state.cursorPosition.ch + this.state.codeSuggestion.length);
                          },
                          "Cmd-Enter": (cm) => {
                            this.runCode();
                          },
                          "Cmd-I": (cm) => {
                            this.toggleCompletion();
                          },
                          "Esc": (cm) => {
                            if (this.state.codeSuggestion) {
                              cm.doc.replaceRange("",
                                { line: this.state.cursorPosition.line, ch: this.state.cursorPosition.ch },
                                { line: this.state.cursorPosition.line, ch: this.state.cursorPosition.ch + this.state.codeSuggestion.length }
                              );
                            }
                          }
                        }
                      }}
                      placeholder="this is the placeholder text"
                    />
                    {/* This is where the DROPDOWN menu goes */}
                    <Dropdown
                      title="Language "
                      list={this.state.language}
                      toggleItem={this.toggleLanguage}
                      className="dropdown"
                      currLang={this.state.currlang}
                    />
                    <div className="aiCard">
                      {this.mapCards()}
                    </div>
                  </div>
                </div>
                <div className="lowerHalf">
                  <div className="lowerMenu evalSec">
                    {/* This is where the CODE EXECUTION happens */}
                    <Eval
                      code={this.state.code}
                      language_id={this.state.language_id}
                      sessionid={this.state.sessionid}
                      evalExtend={this.state.evalExtend}
                      timerExtend={this.state.timerExtend}
                      darkMode={this.props.darkMode}
                      toggleExtend={this.toggleExtend.bind(this)}
                      toggleTimer={this.toggleTimer.bind(this)}
                      toggleWhiteboard={this.toggleWhiteboard.bind(this)}
                      toggleOpenAI={this.toggleOpenAI.bind(this)}
                      toggleBorder={this.toggleBorder.bind(this)}
                      toggleCompletion={this.toggleCompletion.bind(this)}
                      openAiToggle={this.state.openAiToggle}
                      borderToggle={this.state.borderToggle}
                      completionToggle={this.state.completionToggle}
                      toggleFlanT5={this.toggleFlanT5.bind(this)}
                      flanT5Toggle={this.state.flanT5Toggle}
                      anthropicToggle={this.state.anthropicToggle}
                      GrokAIToggle={this.state.GrokAIToggle}
                      GeminiToggle={this.state.GeminiToggle}
                      toggleGrokAI={this.toggleGrokAI.bind(this)}
                      toggleGemini={this.toggleGemini.bind(this)}
                      toggleAnthropic={this.toggleAnthropic.bind(this)}
                      loading={this.state.loading}
                      token={this.state.token}
                      evalOutput={this.state.evalOutput}
                      compileOutput={this.state.compileOutput}
                      time={this.state.time}
                      memory={this.state.memory}
                      evalOutputDB={this.state.evalOutputDB}
                      runCode={this.runCode.bind(this)}
                      login={this.state.login}
                      whiteboardExtend={this.state.whiteboardExtend}
                      openShareModal={this.openShareModal.bind(this)}
                    />
                  </div>
                  <div className="lowerMenu videoSec">
                    {/* This is where the VIDEO CHAT goes */}
                    {this.state.sessionid === null ? (
                      <div />
                    ) : (
                      <VideoChat
                        onAssistantUpdate={this.updateAssistant.bind(this)}
                        aiAssistant={this.state.aiAssistant}
                        whiteboardExtend={this.state.whiteboardExtend}
                        sessionid={this.state.sessionid}
                      />
                    )}
                  </div>
                </div>
              </div>
              {this.whiteboardRender()}
            </div>
          </Hotkeys>
        </React.Fragment>
      </RemoveScroll>);
  }
}

export default CodingPageWrapper;